import PieChart, { ChartDatum } from './PieChart';
import { interpolateOranges } from "d3";
import { iMachineProps } from './Machine';


function VehiclePieChart(props: {pieChart: iMachineProps[]}) {
    // creating map of different vehicle types
    let vehicleTypeMap = new Map()
    for(var i=0;i<props.pieChart.length;i++){
        if(vehicleTypeMap.has(props.pieChart[i].currentCarline)){
            // add to current value
            var currVal = vehicleTypeMap.get(props.pieChart[i].currentCarline) + 1;
            vehicleTypeMap.set(props.pieChart[i].currentCarline, currVal);
        }else{
            // create the value
            vehicleTypeMap.set(props.pieChart[i].currentCarline, 1)
        }
    }
    // list to contain the chart elements
    var data: ChartDatum[] = [];
    vehicleTypeMap.forEach((values,keys)=>{
        var tempChartObj = { label: keys, value: values }
        data.push(tempChartObj)
    });

    return PieChart(data, interpolateOranges);

}



export default VehiclePieChart;
